import Master1 from "./components/master/master1";
import Home from "./components/pages/home";
import LoginPage from "./components/pages/login-page";
import passwordUpdatePage from "./components/pages/password-update-page";
import EditPage from "./components/pages/edit-page";
import Permission from "./components/pages/permission";
import Page from "./components/pages/page";
import CloseShift from "./components/pages/close-shift";
import NoPermission from "./components/pages/no-permmision";
import Report from "./components/pages/report";

const routes = [{
    path: "/",
    component: Master1,
    onEnter: (nextState, replace) => {
        if (!window.localStorage.getItem("token")) {
            replace({
                pathname: "/login",
                state: { nextPathname: nextState.location.pathname }
            });
        }

    },
    indexRoute: { component: Home },
    childRoutes: [
        {
            path: "editpage",
            component: EditPage,
        },
        {
            path: "/404",
            component: NoPermission
        },
        {
            path: "permission/:rowId/:tableName",
            component: Permission

        },
        {
            path: "closeshift",
            component: CloseShift

        },
        {
            path: "/page",
            component: Page,
            childRoutes: [
                {
                    path: "create-employee",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/create-employee").default);
                        });
                    }
                },
                {
                    path: "employee-advance",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/employee-advance").default);
                        });
                    }
                },
                {
                    path: "employee-cash-collection",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/cash-collection").default);
                        });
                    }
                },
                {
                    path: "create-creditor",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/create-creditor").default);
                        });
                    }
                },
                {
                    path: "credit-entry",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/credit-detail").default);
                        });
                    }
                },
                {
                    path: "creditor-payment-entry",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/creditor-payment").default);
                        });
                    }
                },
                {
                    path: "test",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/pages/test-page").default);
                        });
                    }
                },
                {
                    path: "create-product",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-product").default);
                        });
                    }
                },
                {
                    path: "product-rate",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/product-rate").default);
                        });
                    }
                },
                {
                    path: "create-expenditure",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-expenditure-catagory").default);
                        });
                    }
                },
                {
                    path: "expenditure-detail",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-expend-detail").default);
                        });
                    }
                },
                {
                    path: "create-shift",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-shift").default);
                        });
                    }
                },
                {
                    path: "start-shift",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/start-shift").default);
                        });
                    }
                },
                {
                    path: "create-currency",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-currency").default);
                        });
                    }
                },
                {
                    path: "exchange",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/exchange").default);
                        });
                    }
                },
                {
                    path: "create-tank",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-tank").default);
                        });
                    }
                },
                {
                    path: "create-mpd",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/creat-mpd").default);
                        });
                    }
                },
                {
                    path: "create-nozzel",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-nozzel").default);
                        });
                    }
                },
                {
                    path: "create-transaction-account",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create--transaction-account").default);
                        });
                    }
                },
                {
                    path: "create-paymode",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-payment-mode").default);
                        });
                    }
                },
                {
                    path: "create-link-tr-paymode",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/tr-account-payment-mode").default);
                        });
                    }
                },
                {
                    path: "create-swipe",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/creat-swipe-machine").default);
                        });
                    }
                },
                {
                    path: "stock-in",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-stockin").default);
                        });
                    }
                },
                {
                    path: "create-user",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/create-user").default);
                        });
                    }
                },
                {
                    path: "user-edit",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/edit/user-edit").default);
                        });
                    }
                },
                {
                    path: "mpd-nozzel-edit",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/edit/mpd-nozzel-edit").default);
                        });
                    }
                },
                {
                    path: "send-msg",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/send-msg").default);
                        });
                    }
                },
                {
                    path: "msg-subscription",
                    getComponents(location, callback) {
                        callback(null, require("./components/fragments/msg-subscription").default);
                    }
                },
                {
                    path: "backward-stockin",
                    getComponents(location, callback) {
                        callback(null, require("./components/fragments/backward-stockin").default);
                    }
                },
                {
                    path: "last-inspection-entry",
                    getComponents(location, callback) {
                        callback(null, require("./components/fragments/last-inspection-entry").default);
                    }
                },
                {
                    path: "instant-cash-memo",
                    getComponents(location, callback) {
                        callback(null, require("./components/fragments/instant-cash-memo").default);
                    }
                }

            ]
        },
        {
            path: "/report",
            component: Report,
            childRoutes: [
                {
                    path: "current-shift-credit-report",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/current-shift-credit-report").default);
                        });
                    }
                },
                {
                    path: "current-shift-detail-credit-report",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/current-shift-detail-credit-report").default);
                        });
                    }
                },
                {
                    path: "credit-detail-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-detail-between-two-day").default);
                        });
                    }
                },
                {
                    path: "credit-Payment-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-payment-between-two-day").default);
                        });
                    }
                },
                {
                    path: "credit-payment-by-credit-id",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/payment-by-credit-id").default);
                        });
                    }
                },
                {
                    path: "credit-report-by-shift-with-aggreagation",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-detail-between-two-day-with-aggreagation").default);
                        });
                    }
                },
                {
                    path: "credit-report-unbilled",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-unbilled-report").default);
                        });
                    }
                },
                {
                    path: "credit-report-unbilled-bycreditor/:id/:firmName",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-report-unbilled-bycreditor-Id").default);
                        });
                    }
                },
                {
                    path: "credit-report-billed",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-report-billed").default);
                        });
                    }
                },
                {
                    path: "credit-report-billed-by-id",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/billed-report-by-credit-id").default);
                        });
                    }
                },
                {
                    path: "credit-report-billed-bycreditor/:id/:firmName",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-report-billed-bycreditor-Id").default);
                        });
                    }
                },
                {
                    path: "credit-report-bybillid/:creditorId/:creditorBillId/:firmName",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-report-bybill-id").default);
                        });
                    }
                },
                {
                    path: "creditor-payment-bycreditorId/:creditorId/:firmName",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/creditor-payment-by-creditorId").default);
                        });
                    }
                },
                {
                    path: "credit-statement",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/creditor-statement").default);
                        });
                    }
                },

                {
                    path: "credit-account-details",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/credit-account-details").default);
                        });
                    }
                },
                {
                    path: "reading-report",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/reading-report").default);
                        });
                    }
                },
                {
                    path: "chart",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/chart").default);
                        });
                    }
                },
                {
                    path: "employee-advance-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/employee-advance-by-two-date").default);
                        });
                    }
                },
                {
                    path: "current-shift-employee-advance",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/current-shift-employee-advance").default);
                        });
                    }
                },
                {
                    path: "salary-payment-by-date",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/salary-payment-report-by-date").default);
                        });
                    }
                },
                {
                    path: "employee-attendance-shortage",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/employyee-attendance-shortage").default);
                        });
                    }
                },
                {
                    path: "employee-salary-detail",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/salary-report").default);
                        });
                    }
                },
                {
                    path: "employee-pay-rate",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/employee-pay-rate").default);
                        });
                    }
                },
                {
                    path: "current-shift-expenditure",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/current-shift-expenditure-report").default);
                        });
                    }
                },
                {
                    path: "expenditure-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/expenditure-between-two-day").default);
                        });
                    }
                },
                {
                    path: "expenditure-between-two-day-with-aggreagation",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/expenditure-between-two-day-with-aggreagation").default);
                        });
                    }
                },
                {
                    path: "sell",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/sell-report").default);
                        });
                    }
                },
                {
                    path: "sell-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/sell-report-day-wise ").default);
                        });
                    }
                },
                {
                    path: "current-shift-cash-collection",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/current-shift-cash-collection").default);
                        });
                    }
                },
                {
                    path: "swipe-ungrouped",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/swipe-ungrouped").default);
                        });
                    }
                },
                {
                    path: "swipe-grouped",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/swipe-grouped").default);
                        });
                    }
                },
                {
                    path: "product-rate-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/product-rate-report-between-two-day").default);
                        });
                    }
                },
                {
                    path: "current-shift-cash-transaction",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/current-shift-cash-transaction").default);
                        });
                    }
                },
                {
                    path: "close-shift-report-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/close-shift-report-between-two-day").default);
                        });
                    }
                },
                {
                    path: "closed-shift-report/:shiftId/:shiftDate",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/closed-shift-report").default);
                        });
                    }
                },
                {
                    path: "invoice-report-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/invoice-report-between-two-day").default);
                        });
                    }
                },
                {
                    path: "invoice-shortage-report-between-two-day",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/invoice-shortage-report").default);
                        });
                    }
                },
                {
                    path: "get-interest-report",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/interest-report").default);
                        });
                    }
                },
                {
                    path: "msg-subscription-report",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/msg-subscription-report").default);
                        });
                    }
                },
                {
                    path: "dsr",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/dsr").default);
                        });
                    }
                },

                {
                    path: "small-creditor-account-statement",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/small-creditor-account-stament").default);
                        });
                    }

                },
                {
                    path: "all-small-creditor-statement",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/all-small-creditor-statement").default);
                        });
                    }

                },
                {
                    path: "all-small-creditor-report-between-two-dates",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/all-small-creditor-report-between-two-dates").default);
                        });
                    }

                },
                {
                    path: "close-shift-dips",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/close-shift-dips").default);
                        });
                    }

                },
                {
                    path: "showall-creditors",
                    getComponents(location, callback) {
                        require.ensure([], function (require) {
                            callback(null, require("./components/fragments/reports/showall-creditors").default);
                        });
                    }
                }

            ]
        },
        {
            path: "/edit-page",
            component: Page,
            childRoutes: [
                {
                    path: "creditor",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/edit/creditor-edit").default);
                        });
                    }
                },
                {
                    path: "employee",
                    getComponents(location, callback) {
                        require.ensure([], () => {
                            callback(null, require("./components/fragments/edit/employee-edit").default);
                        });
                    }
                },

            ]
        }

    ]

},
{
    path: "/login",
    component: LoginPage,
    onEnter: (nextState, replace) => {

        if (window.localStorage.getItem("token")) {
            replace({
                pathname: "/",
                state: { nextPathname: nextState.location.pathname }
            });
        }

    }
},
{
    path: "/update-password",
    component: passwordUpdatePage
}

];

export default routes;


// WEBPACK FOOTER //
// ./src/jsx/routes.jsx